import { type Plugin } from "chart.js";

export const HIGHLIGHT_DATASET_ON_HOVER_PLUGIN_ID = "highlightDatasetOnHover";

export const highlightDatasetOnHoverPlugin: Plugin = {
  id: HIGHLIGHT_DATASET_ON_HOVER_PLUGIN_ID,
  /* install(chart: Chart<any>) {
       chart.canvas.addEventListener("mouseout", (event) => {
         chart.config.data.datasets.forEach((dataset) => {
           dataset.borderColor = "rgba(0,0,0,0)";
         });
       });
     },
     beforeDatasetsDraw(chart: Chart<any>, _args: any, _options: any) {
       const datasetMetas = chart.getSortedVisibleDatasetMetas();
       console.log("metas", { datasetMetas, chart });
       for (let i = 0; i < datasetMetas.length; i++) {
         const datasetMeta = datasetMetas[i];
         const index = datasetMeta.index;
         if (datasetMeta.data.some(({ active }) => active)) {
           // chart.config.data.datasets[i].borderColor = "red";
           chart.config.data.datasets[index].backgroundColor = "#FF0000";
           chart.config.data.datasets[index].borderColor = "#FF0000";
           // chart.update("none");
           break;
         }
       }
     },
     afterEvent(chart: Chart<any>, args: any) {
       if (args.inChartArea) {
         const setBorderColor = (
           active: boolean,
           index: number,
           borderColor: string,
         ) => (active ? borderColor : "rgba(0,0,0,0)"); */

  /*     chart.config.data.datasets.forEach((dataset, index) => {
           dataset.borderColor = setBorderColor(
             dataset.data.some(({ active }: any) => active),
             index,
             "red",
           );
         });
         args.changed = true;
       }
     }, */
};
